import { ActionCreator } from "./../types/store-types";
import {
    ActivatePaymentMethodCashActionType,
    AuthPayPalUserRequestActionType,
    DisconnectPaymentMethodActionType,
    PaymentActionTypes,
    UpdatePaymentRequestActionType,
    CreatePromoCodeActionType,
    UpdatePromoCodeActionType,
    DuplicatePromoCodeActionType,
    DeletePromoCodeActionType,
    AuthStripeUserRequestActionType,
    ConfirmStripeAuthRequestActionType,
    ChangeIsShowPromoCodeFieldActionType,
    ChangeIsShowPaymentTypeFieldActionType,
    InitPayableFieldsActionType,
    InitPaymentDataActionType,
    AuthSquareUserRequestActionType,
    GetSquareSubsRequestActionType,
    GetSquareSubsSuccessActionType,
    GetSquareSubsFailureActionType,
} from "./types";

export const initPaymentData: ActionCreator<InitPaymentDataActionType> = payload => ({
    type: PaymentActionTypes.INIT_PAYMENT_DATA,
    payload,
});

export const initPayableFields: ActionCreator<InitPayableFieldsActionType> = payload => ({
    type: PaymentActionTypes.INIT_PAYABLE_FIELDS,
    payload,
});

export const updatePaymentRequest: ActionCreator<UpdatePaymentRequestActionType> = payload => ({
    type: PaymentActionTypes.UPDATE_PAYMENT_REQUEST,
    payload,
});

export const authPayPalUserRequest: ActionCreator<AuthPayPalUserRequestActionType> = payload => ({
    type: PaymentActionTypes.AUTH_PAYPAL_USER_REQUEST,
    payload,
});

export const authStripeUserRequest: ActionCreator<AuthStripeUserRequestActionType> = payload => ({
    type: PaymentActionTypes.AUTH_STRIPE_USER_REQUEST,
    payload,
});
export const authSquareUserRequest: ActionCreator<AuthSquareUserRequestActionType> = payload => ({
    type: PaymentActionTypes.AUTH_SQUARE_USER_REQUEST,
    payload,
});

export const getSquareSubsRequest: ActionCreator<GetSquareSubsRequestActionType> = payload => ({
    type: PaymentActionTypes.GET_SQUARE_SUBSCRIPTIONS_REQUEST,
    payload,
});
export const getSquareSubsSuccess: ActionCreator<GetSquareSubsSuccessActionType> = payload => ({
    type: PaymentActionTypes.GET_SQUARE_SUBSCRIPTIONS_SUCCESS,
    payload,
});
export const getSquareSubsFailure: ActionCreator<GetSquareSubsFailureActionType> = payload => ({
    type: PaymentActionTypes.GET_SQUARE_SUBSCRIPTIONS_FAILURE,
    payload,
});

export const confirmStripeAuthRequest: ActionCreator<ConfirmStripeAuthRequestActionType> = payload => ({
    type: PaymentActionTypes.CONFIRM_STRIPE_AUTH_REQUEST,
    payload,
});

export const disconnectPaymentMethodRequest: ActionCreator<DisconnectPaymentMethodActionType> = payload => ({
    type: PaymentActionTypes.DISCONNECT_PAYMENT_METHOD,
    payload,
});

export const activateCashPaymentRequest: ActionCreator<ActivatePaymentMethodCashActionType> = payload => ({
    type: PaymentActionTypes.ACTIVATE_PAYMENT_METHOD_CASH,
    payload,
});

export const createPromoCodeRequest: ActionCreator<CreatePromoCodeActionType> = payload => ({
    type: PaymentActionTypes.CREATE_PROMOCODE,
    payload,
});

export const updatePromoCodeRequest: ActionCreator<UpdatePromoCodeActionType> = payload => ({
    type: PaymentActionTypes.UPDATE_PROMOCODE,
    payload,
});

export const duplicatePromoCodeRequest: ActionCreator<DuplicatePromoCodeActionType> = payload => ({
    type: PaymentActionTypes.DUPLICATE_PROMOCODE,
    payload,
});
export const deletePromoCodeRequest: ActionCreator<DeletePromoCodeActionType> = payload => ({
    type: PaymentActionTypes.DELETE_PROMOCODE,
    payload,
});

export const changeIsShowPromoCodeField: ActionCreator<ChangeIsShowPromoCodeFieldActionType> = payload => ({
    type: PaymentActionTypes.CHANGE_IS_SHOW_PROMOCODE_FIELD,
    payload,
});

export const changeIsShowPaymentTypeField: ActionCreator<ChangeIsShowPaymentTypeFieldActionType> = payload => ({
    type: PaymentActionTypes.CHANGE_IS_SHOW_PAYMENT_TYPE_FIELD,
    payload,
});
